import { Link } from "react-router-dom";

import { Globe } from "lucide-react";

interface FooterProps {
  onContactUs?: () => void;
}

const Footer = ({ onContactUs }: FooterProps) => {
  return (
    <footer className="w-full py-16 border-t border-surface-container-high bg-surface-container-low">
      <div className="max-w-8xl mx-auto px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
          <div className="space-y-5 max-w-md">
            <div className="flex items-center gap-3 font-headline font-extrabold text-2xl text-on-surface tracking-tight">
              <img src="/logo.svg" alt="AppearInAISearch" className="w-12 h-12" /> AppearInAISearch
            </div>
            <p className="text-on-surface-variant leading-relaxed">
              The premier intelligence platform for AI search optimization. Ensuring your brand is
              the first answer in the age of artificial intelligence.
            </p>
          </div>

          <div className="space-y-5">
            <h5 className="font-headline font-bold text-on-surface text-lg">Solutions</h5>
            <ul className="space-y-3 text-on-surface-variant">
              <li>
                <Link to="/audit" className="hover:text-primary transition-colors">
                  AI Audit
                </Link>
              </li>
              <li>
                <Link to="/llm-visibility" className="hover:text-primary transition-colors">
                  LLM Visibility
                </Link>
              </li>
              <li>
                <Link to="/persona" className="hover:text-primary transition-colors">
                  Persona Visibility
                </Link>
              </li>
              <li>
                <Link to="/ota-direct" className="hover:text-primary transition-colors">
                  OTA vs Direct
                </Link>
              </li>
              <li>
                <Link to="/perception" className="hover:text-primary transition-colors">
                  AI Perception
                </Link>
              </li>
              <li>
                <Link to="/google-analytics" className="hover:text-primary transition-colors">
                  Google Analytics
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="hover:text-primary transition-colors">
                  ROI Calculator
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-5">
            <h5 className="font-headline font-bold text-on-surface text-lg">About Us</h5>
            <ul className="space-y-3 text-on-surface-variant">
              <li>
                <Link to="/partners" className="hover:text-primary transition-colors">
                  Partners
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-primary transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <button onClick={onContactUs} className="hover:text-primary transition-colors">
                  Contact Us
                </button>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/sarucci/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-5">
            <h5 className="font-headline font-bold text-on-surface text-lg">Other Products</h5>
            <ul className="space-y-3 text-on-surface-variant">
              <li>
                <a
                  href="https://sarucci.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  Sarucci
                </a>{" "}
                <span className="text-xs text-on-surface-variant/60">(Hotel RMS)</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-on-surface-variant/70 text-sm border-t border-surface-container-high pt-8">
          <p>&copy; {new Date().getFullYear()} Sarucci. All Rights Reserved.</p>
          <div className="flex items-center gap-8">
            <Link to="/privacy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms and Conditions
            </Link>
            <div className="flex items-center gap-2">
              <Globe className="w-4 h-4" />
              English (US)
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
